<template>
  <body id="app">
      <Header />
      <main>
          <section class="container">
              <div class="grid-row grid-row--center">
                <button class="btn mt1 mr1" v-bind:class="tagClass(tag)"  @click="toggleTag(tag)" v-for="tag in tags">
                    {{tag}}
                </button>
              </div>
              <div class="grid-row">
                <div class="grid-column span-one-third mt1" v-for="project in projects" v-if="showProject(project)">
                  <Project v-bind:project="project" />
                </div>
              </div>
          </section> <!-- End container -->

          <!-- Blurbs -->
          <section class="container--sm pt2 pb4">
          </section>
      </main>

      <!-- Footer -->
      <Footer />
  </body>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'
import Project from './components/Project'
export default {
  name: 'app',
  components: {
      Header,
      Footer,
      Project
  },

  data() {
      return {
          tags: ["game", "education", "health", "productivity", "social", "iOS", "android", "web"],
          activeTags: [],
          projects: [
            {
                name: 'Hungry snake | 贪食蛇',
                image: require('./assets/chefy-hungry-snakes.png'),
                tagline: 'Classic ',
                overlayClass: "overlay--red",
                links: [],
                detail: "Old school hungry snake game",
                release_time: "Feb, 2021",
                tags: ["game", "iOS", "android"]
            },
            {
                name: 'Goals App',
                image: require('./assets/chefy-goals.png'),
                tagline: 'Manage your time and tasks',
                overlayClass: "overlay--purple",
                links: [],
                detail: "Goals app integrates timer and todo list in one, making it easier for you to budget your time",
                release_time: "Jan, 2021",
                tags: ["productivity", "web", "iOS", "android"]
            },
            {
                name: 'America Civics',
                image: require('./assets/chefy-america-civics.png'),
                tagline: '2020 USCIS Citizenship Civic',
                overlayClass: "overlay--blue",
                links: [
                  { type: "web", value: "https://america-civics.chefy.io" },
                  { type: "iOS", value: "https://apps.apple.com/us/app/america-civics/id1542466461" },
                  { type: "android", value: "https://play.google.com/store/apps/details?id=io.chefy.america_civics" }
                ],
                detail: "study guide 2020 USCIS Citizenship Civic tests",
                release_time: "November, 2020",
                tags: ["education", "web", "iOS", "android"]
            },
            {
                name: 'Cards Against Distance',
                image: require('./assets/chefy-cards-against-distance.png'),
                tagline: 'Play virtual card games',
                overlayClass: "overlay--red",
                links: [
                  { type: "web", value: "https://cardsagainstdistance.com" }
                ],
                detail: "play card games online with friends",
                release_time: "June, 2020",
                tags: ["game", "web"]
            },
            {
                name: 'Medico',
                image: require('./assets/chefy-medico.png'),
                tagline: 'Learn Spanish medical words',
                overlayClass: "overlay--blue",
                links: [
                  { type: "web", value: "https://medico.chefy.io" }
                ],
                detail: "Learn Spanish medical words and phrases",
                release_time: "March, 2020",
                tags: ["education", "web"]
            },
            {
                name: 'Scripts',
                image: require('./assets/chefy-scripts.png'),
                tagline: 'Create scripts with ease',
                overlayClass: "overlay--turquoise",
                links: [
                  { type: "web", value: "https://scripts.chefy.io" }
                ],
                detail: "Scripts is a collection of tools that help software developer with daily scripting tasks, like copy and paste data from spreadsheet to console.",
                release_time: "Jan, 2020",
                tags: ["productivity", "web"]
            },
            {
                name: 'Kana',
                image: require('./assets/chefy-kana.png'),
                tagline: 'Learn Japanese Hiragana',
                overlayClass: "overlay--purple",
                links: [
                    { type: "ios", value: "https://apps.apple.com/us/app/kana-learn-japanese-hiragana/id1473208959?ls=1" }
                ],
                detail: "Kana helps users to learn basic Japanse hiragana by rapid review and quiz.",
                release_time: "Aug, 2019",
                tags: ["education", "iOS"]
            },
            {
                name: 'Repose',
                image: require('./assets/chefy-repose.png'),
                tagline: 'Guided meditation',
                overlayClass: "overlay--blue",
                links: [
                    { type: "android", value: "https://play.google.com/store/apps/details?id=io.chefy.repose" },
                    { type: "ios", value: "https://apps.apple.com/us/app/repose-relax-rest-reflect/id1450201889?ls=1" }
                ],
                detail: "Repose is yet another meditation app that provides ambient background music for meditation.",
                release_time: "Jan, 2019",
                tags: ["health", "iOS", "android"]
            },
            {
                name: 'Maestro',
                image: require('./assets/chefy-maestro.png'),
                tagline: 'Music theory teacher',
                overlayClass: "overlay--purple",
                links: [
                    { type: "android", value: "https://play.google.com/store/apps/details?id=io.chefy.maestro" },
                    { type: "ios", value: "https://itunes.apple.com/us/app/maestro-online-music-teacher/id1400089290?mt=8" }
                ],
                detail: "Maestro is a comprehensive music theory learning app that allows users to learn and practice signt reading, ear training, and more.",
                release_time: "May, 2018",
                tags: ["education", "iOS", "android"]
            },
            {
                name: 'Leo',
                image: require('./assets/chefy-leo.png'),
                tagline: 'Read literature in English, Español, 中文',
                overlayClass: "overlay--red",
                links: [
                    { type: "android", value: "https://play.google.com/store/apps/details?id=io.chefy.leo" },
                    { type: "ios", value: "https://itunes.apple.com/us/app/leo-daily-literature-reader/id1378477379?mt=8" }
                ],
                detail: "Leo is a short literature reading app in English, Spanish, and Chinese.",
                release_time: "March, 2018",
                tags: ["education", "iOS", "android"]
            },
            {
                name: 'Broker Notes',
                image: require('./assets/chefy-broker-notes.png'),
                overlayClass: "overlay--blue",
                tagline: 'Real estate broker study guide',
                links: [
                    { type: "android", value: "https://play.google.com/store/apps/details?id=io.chefy.brokernotes" },
                    { type: "ios", value: "https://itunes.apple.com/us/app/broker-notes/id1351101355?mt=8" },
                    { type: "web", value: "https://broker-notes.com" }
                ],
                detail: "Broker Notes is an education app that help people study to become a real estate agent.",
                release_time: "Jan, 2018",
                tags: ["education", "iOS", "android", "web"]
            },
            {
                name: 'Clojure Katas',
                image: require('./assets/chefy-clojure-katas.png'),
                overlayClass: "overlay--green",
                tagline: 'Learn Clojure by doing coding practice',
                links: [
                    { type: "web", value: "https://clojure.chefy.io" }
                ],
                detail: "Learn Clojure by tackling coding exercises",
                release_time: "Jan, 2016",
                tags: ["education", "web"]
            },
          ]
      }
  },
  
  methods: {
    toggleTag: function(tag) {
        let activeTagSet = new Set(this.activeTags)
        if (activeTagSet.has(tag)) {
            activeTagSet.delete(tag)
        } else {
            activeTagSet.add(tag)
        }
        this.activeTags = Array.from(activeTagSet)
    },
    tagClass: function(tag) {
        let activeTagSet = new Set(this.activeTags)
        return activeTagSet.has(tag) ? "btn--default" : "btn--outline"
    },
    showProject: function(project) {
        if (this.activeTags.length == 0) { return true }
        let projectTags = new Set(project.tags)
        let intersect = new Set(this.activeTags.filter(t => projectTags.has(t)))
        return intersect.size > 0
    }
  }
}
</script>

<style lang="scss">
  @import './scss/main.scss'
</style>



// WEBPACK FOOTER //
// src/App.vue